<div class="widget-newsletter__title">
    <h4>Newsletter</h4>
</div>
<div class="widget-newsletter__form">
    <form action="">
        <div class="widget-newsletter__text">
            Enter your email address below to subscribe to our newsletter
            and keep up to date with the latest news, discounts and special offers.
        </div>
        <input type="text" class="widget-newsletter__email" placeholder="Email Address...">
        <button type="button" class="widget-newsletter__button">Subscribe</button>
    </form>
</div>
